import superagent from 'superagent';

function noCache(request) {
  request.set('Cache-Control', 'no-cache');
  request.set('Pragma', 'no-cache');
  return request;
}

const agent = navigator.userAgent.toLowerCase();
let isIE = false;
if ((navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) || agent.indexOf('msie') !== -1) {
  isIE = true;
}

const finalNoCache = isIE ? noCache : () => {};

const errorState = res => {
  try {
    if (res.status === 400 || res.status === 401 || res.status === 404 || res.status === 500) {
      // console.log('400 401 404 500 error');
    } else if (res.status === '403') {
      // console.log('인증, 세션 오류');
    }
  } catch (err) {
    // console.log(err);
  }
};

const responseBody = res => {
  if (res.body !== null) return res.body;
  return res;
};

const responseBodyHtml = res => {
  if (res && res.text !== null) return res.text;
  return res;
};

// API 호출 error
const errorCatchCallback = (err, url) => {
  if (err.errno === 'ETIMEDOUT') {
    // console.log('timeout');
    const returnResponse = {
      ...err,
      errorCode: 'MB_M_PERSONALINFO_ERR_TIMEOUT',
    };
    throw returnResponse;
  }
  if (err.crossDomain) {
    // console.log('crossDomain');
    const returnResponse = {
      ...err,
      errorCode: 'crossDomain',
    };
    throw returnResponse;
  } else if (err.response && (err.response.status === 404 || err.response.status === 302)) {
    const returnResponse = {
      ...err,
      errorMessage: 'CO400',
    };
    throw returnResponse;
  } else if (err.response && err.response.status !== 200) {
    // 조판 숨김/삭제 예외 처리 메세지
    errorState(err.response);
  }

  if (err.response?.header['content-type'].includes('text/html')) {
    const returnResponse = {
      ...err,
      errorResponse: 'MB_M_PERSONALINFO_ERR_TIMEOUT',
    };
    throw returnResponse;
  }
  // else text = message(`error.${err.errno || err.errorCode}`) || err.errorMessage;
  // showMessagePopup({
  //     text
  // });
  // console.log('err', err.response);
  // console.error(`${url} 호출 에러`, JSON.stringify(err));
  throw err.response && err.response.body;
};
const retryCount = 0;

const requests = {
  del: url =>
    superagent
      .del(url)
      .withCredentials()
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  get: (url, responseTimeout) =>
    superagent
      .get(url)
      .withCredentials()
      .set('Content-type', 'application/json')
      .use(finalNoCache)
      .timeout({
        response: responseTimeout !== undefined ? responseTimeout : 10000,
        deadline: 60000,
      })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  put: (url, body) =>
    superagent
      .put(url, body)
      .withCredentials()
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  post: (url, body) =>
    superagent
      .post(url, body)
      .withCredentials()
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBody)
      .catch(err => errorCatchCallback(err, url)),
  attach: (url, formData) => superagent.post(url, formData),
  getHtml: (url, body) =>
    superagent
      .post(url, body)
      .type('form')
      .withCredentials()
      .timeout({ response: 10000, deadline: 60000 })
      .retry(retryCount)
      .then(responseBodyHtml)
      .catch(err => errorCatchCallback(err, url)),
};
export default requests;
